import { z } from "zod"
import errorMap from "./validation-error-map"
import { normalisedEmailValidation } from "./validation-email"

export const ValidLoginSchema = z.object({
   email: normalisedEmailValidation,
   password: z.string({ errorMap }).min(1)
})
